(function() {
    'use strict';
    angular
        .module('publicGatewayApp')
        .factory('City', City);

    City.$inject = ['$resource', 'DateUtils'];

    function City ($resource, DateUtils) {
        var resourceUrl =  'api/cities/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.modificationDate = DateUtils.convertLocalDateFromServer(data.modificationDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.modificationDate = DateUtils.convertLocalDateToServer(copy.modificationDate);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.modificationDate = DateUtils.convertLocalDateToServer(copy.modificationDate);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();
